exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-0ddcc5a6] {\n  font-size: 29px;\n  font-weight: bold;\n  line-height: 42px;\n  color: #000;\n  margin-bottom: 36px;\n  text-align: center;\n}\n@media (max-width: 768px) {\n.title[data-v-0ddcc5a6] {\n    font-size: 18px;\n    line-height: 23px;\n    margin-bottom: 15px;\n}\n}\n.sub_title[data-v-0ddcc5a6] {\n  font-size: 18px;\n  line-height: 26px;\n  color: #02A1E9;\n  margin-bottom: 36px;\n  text-align: center;\n}\n@media (max-width: 768px) {\n.sub_title[data-v-0ddcc5a6] {\n    font-size: 14px;\n    line-height: 17px;\n    margin-bottom: 15px;\n}\n}", ""]);

// exports
